"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
var AgeComparaBrackets;
(function (AgeComparaBrackets) {
    AgeComparaBrackets["LOW"] = "low";
    AgeComparaBrackets["MEDIUM_LOW"] = "mediumLow";
    AgeComparaBrackets["MEDIUM"] = "medium";
    AgeComparaBrackets["MEDIUM_HIGH"] = "mediumHigh";
    AgeComparaBrackets["HIGH"] = "high";
})(AgeComparaBrackets || (AgeComparaBrackets = {}));
class HautAgeBucket {
    constructor() {
        this._ageBucketData = [];
        this._userAgeBucketData = [];
        this._isInit = false;
        this.ageBucketRange = [];
        console.log('[age-bucket.haut.api.constructor()]: ', 'INVOKED');
        console.log('[age-bucket.haut.api.ageComparisonApiUrl]: ');
        this.userAgeBucketMap = new Map();
    }
    init(userAge, hautMeta, brandConfig, ageComparisonApiUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            console.log('[age-bucket.haut.api.init()]: ', 'INVOKED');
            if (this._isInit)
                return this;
            console.log('[age-bucket.haut.api.init()]: ', 'INITIALIZING AGE BUCKET DATA');
            userAge < 18 && (userAge = 18);
            this._userAge = userAge;
            this._hautMeta = hautMeta;
            const { name, locale, version } = brandConfig;
            const { companyId, datasetId } = this._hautMeta;
            const brandKeyWord = `${name}-${locale}-${version}`.toLowerCase();
            const url = `${ageComparisonApiUrl}/${brandKeyWord}/${companyId}/${datasetId}/algorithms_bucket.json`;
            try {
                const ageComparisonResponse = yield (0, axios_1.default)({
                    method: 'GET',
                    responseType: 'json',
                    url,
                });
                this._ageBucketData = ((_c = (_b = (_a = ageComparisonResponse.data) === null || _a === void 0 ? void 0 : _a.results[0]) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.buckets) || [];
                this._userAgeBucketData = this._ageBucketData.filter(bucket => {
                    const { age_group: [min, max], algorithm_tech_name, } = bucket;
                    const isUserAgeBucket = min <= userAge && userAge <= max;
                    if (isUserAgeBucket) {
                        this.userAgeBucketMap.set(algorithm_tech_name, bucket);
                    }
                    return isUserAgeBucket;
                });
                console.log('[age-bucket.haut.api.init._userAge]: ', this._userAge);
                console.log('[age-bucket.haut.api.init._ageBucketData]: ', this._ageBucketData);
                console.log('[age-bucket.haut.api.init._userAgeBucketData]: ', this._userAgeBucketData);
                console.log('[age-bucket.haut.api.init._userAgeBucketMap]: ', this.userAgeBucketMap);
                this._isInit = true;
                return this;
            }
            catch (error) {
                throw error;
            }
        });
    }
    getUserAgeBasedMap(userAge, hautMeta, brandConfig, ageComparisonApiUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._isInit) {
                yield this.init(userAge, hautMeta, brandConfig, ageComparisonApiUrl);
            }
            return this.userAgeBucketMap;
        });
    }
    setAttributeStatus(skinAnalysisResponse) {
        return skinAnalysisResponse.map(skinAttributeInfo => {
            const { score, algorithmTechName } = skinAttributeInfo;
            const ageAttributeScore = this.userAgeBucketMap.get(algorithmTechName);
            if (score >= 0 && score <= ageAttributeScore.bucket1) {
                skinAttributeInfo.status = AgeComparaBrackets.LOW;
            }
            else if (score > ageAttributeScore.bucket1 && score <= ageAttributeScore.bucket2) {
                skinAttributeInfo.status = AgeComparaBrackets.MEDIUM_LOW;
            }
            else if (score > ageAttributeScore.bucket2 && score <= ageAttributeScore.bucket3) {
                skinAttributeInfo.status = AgeComparaBrackets.MEDIUM;
            }
            else if (score > ageAttributeScore.bucket3 && score <= ageAttributeScore.bucket4) {
                skinAttributeInfo.status = AgeComparaBrackets.MEDIUM_HIGH;
            }
            else if (score > ageAttributeScore.bucket4 && score <= ageAttributeScore.bucket5) {
                skinAttributeInfo.status = AgeComparaBrackets.HIGH;
            }
            return skinAttributeInfo;
        });
    }
    getAgeBuckets() {
        console.log('[age-bucket.haut.api.getAgeBuckets]', 'FORMATTING API RESPONSE');
        if (this.ageBucketRange.length) {
            console.log('[age-bucket.haut.api.getAgeBuckets._ageBucketRange]', this.ageBucketRange);
            return this.ageBucketRange;
        }
        const algoAgeBuckets = this._ageBucketData.filter(bucket => bucket.algorithm_tech_name === this._ageBucketData[0].algorithm_tech_name);
        const ageBuckets = [];
        algoAgeBuckets.forEach(bucket => {
            const [min, max] = bucket.age_group;
            ageBuckets.push({
                id: min,
                label: `${min}${max === 999 ? '+' : `-${max}`}`,
                value: `${min}-${max}`,
            });
        });
        this.ageBucketRange = ageBuckets;
        console.log('[age-bucket.haut.api.getAgeBuckets._ageBucketRange]', this.ageBucketRange);
        return this.ageBucketRange;
    }
    getAgeBasedScores(preferredBucket) {
        console.log('[age-bucket.haut.api.getAgeBasedScores]', 'FORMATTING API RESPONSE');
        const agebasedAttributeScores = this._userAgeBucketData.map(ageData => {
            return {
                algorithm_tech_name: ageData['algorithm_tech_name'],
                score: ageData[preferredBucket],
            };
        });
        console.log('[age-bucket.haut.api.preferredBucket]: ', preferredBucket);
        console.log('[age-bucket.haut.api.filteredAgeBucketData]: ', agebasedAttributeScores);
        return agebasedAttributeScores;
    }
    getSkinComarisonResult(skinAnalysisResult, ageRange, ageBucket) {
        console.log('[age-bucket.haut.api.formatSkinComparisonResult]', 'FORMATTING API RESPONSE');
        const formattedResult = skinAnalysisResult.map(item => {
            const comparedResult = this._ageBucketData.filter(result => {
                return result.algorithm_tech_name === item.algorithmTechName && ageRange === result.age_group.join('-');
            });
            return {
                atrribute: item.attribute,
                comparedScore: comparedResult.length > 0 ? comparedResult[0][ageBucket.compareBucket] : null,
                score: item.score,
                type: item.status,
            };
        });
        const filteredAttributes = formattedResult.filter(item => {
            return item.comparedScore !== null;
        });
        return filteredAttributes;
    }
    getAgeBasedResults(skinAnalysisResult, preferredBucket) {
        console.log('[age-bucket.haut.api.getAgeBasedResults]', 'FORMATTING API RESPONSE');
        const concernsArray = [];
        const topResultsArray = [];
        skinAnalysisResult.forEach(result => {
            if (result['status']) {
                //need to change in age bucket and remove below line code
                //REMOVE
                result['algorithmTechName'] === 'lines' && (result['algorithmTechName'] = 'wrinkles');
                //END
                const element = this.userAgeBucketMap.get(result['algorithmTechName']);
                if (result['status'] === AgeComparaBrackets.LOW || result['status'] === AgeComparaBrackets.MEDIUM_LOW || result['status'] === AgeComparaBrackets.MEDIUM) {
                    concernsArray.push({
                        concern: result,
                        difference: result.score - element[preferredBucket],
                    });
                }
                else if (result['status'] === AgeComparaBrackets.MEDIUM_HIGH || result['status'] === AgeComparaBrackets.HIGH) {
                    topResultsArray.push({
                        result,
                        difference: result.score - element[preferredBucket],
                    });
                }
            }
        });
        concernsArray.sort((a, b) => a.difference - b.difference);
        topResultsArray.sort((a, b) => b.difference - a.difference);
        console.log('[age-bucket.haut.api.getAgeBasedResults.concernsArray.sort]', concernsArray);
        console.log('[age-bucket.haut.api.getAgeBasedResults.topResultsArray.sort]', topResultsArray);
        const concerns = concernsArray.map(({ concern }) => concern);
        const topResults = topResultsArray.map(({ result }) => result).sort((a, b) => b.score - a.score);
        concerns.length > 3 && (concerns.length = 3);
        topResults.length > 3 && (topResults.length = 3);
        return { concerns, topResults };
    }
    getConcernAreaMaskingDataResults(skinAnalysisResult, concerns) {
        console.log('[age-bucket.haut.api.getConcernAreaMaskingDataResults]');
        const evaluationArray = [];
        skinAnalysisResult.forEach((result) => {
            if (concerns.includes(result.algorithmVersionId)) {
                evaluationArray.push(result);
            }
        });
        return evaluationArray;
    }
}
const skinComparisonService = new HautAgeBucket();
exports.default = skinComparisonService;
